/**
 * Sanitizes a percentage input string.
 *
 * - Removes all non-digit characters.
 * - Strips leading zeros.
 * - Clamps the numeric value between 0 and 100.
 * - Returns the sanitized value as a string, or an empty string if no digits remain.
 *
 * @param raw - The raw input string to sanitize.
 * @returns A string representing a percentage value between "0" and "100", or "" if empty.
 */
export const sanitizePercent = (raw?: string) => {
  const digits = String(raw ?? "").replace(/\D/g, "");
  if (digits === "") return "";
  const noLeading = digits.replace(/^0+(?=\d)/, "");
  const n = Math.min(100, Math.max(0, parseInt(noLeading, 10)));
  return String(n);
};
